import React from "react";
import { ReactComponent as CenterDotIcon } from "assets/CenterDotIcon.svg";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import InitiativeIcon from "assets/InitiativeIcon";
import KPIIcon from "assets/KPIIcon";

export const usePeriodChipStyles = makeThemedStyles("PeriodChip", (theme) => ({
  iconContainer: {
    marginLeft: "3px",
    marginRight: "3px",
  },
  root: {
    fontSize: "12px",
    lineHeight: "1.25em",
    padding: "0.37em 1.33em",
    color: "rgba(76, 81, 87, 1)",
    margin: "10px 0 14px 0",
    gap: "2px",
    borderRadius: "1.25em",
    top: "0.833em",
    right: "50%",
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(225, 245, 255, 1)",
  },
}));

const PeriodChip = (
  props: React.PropsWithChildren<{
    period: string;
    title?: string;
    icon?: "KPI" | "Initiative";
  }>
) => {
  const classes = usePeriodChipStyles();
  const { period, title } = props;
  return (
    <>
      <div className={classes.root}>
        {props.icon ? (
          <div className={classes.iconContainer}>
            {props.icon === "Initiative" ? (
              <InitiativeIcon size={16} />
            ) : props.icon === "KPI" ? (
              <KPIIcon size={16} />
            ) : null}
          </div>
        ) : null}

        {title && (
          <>
            {title}
            <CenterDotIcon />
          </>
        )}
        {period}
        {props.children}
      </div>
    </>
  );
};

export default PeriodChip;
